export {
  emailSignup,
  enquiry
} from './GeneralApi'

export {
  register,
  login,
  logout,
  resendVerifyEmail,
  verifyAccount,
  forgotPassword,
  resetPassword
} from './SessionApi'

export {
  getMyUser,
  updateUser,
  changePassword,
  createOrg,
  getOrgs,
  acceptOrgInvite,
  purchasePremium,
  purchaseTeam,
  getSubscription,
  cancelSubscription,
  renewSubscription,
  getPaymentMethod,
  updatePaymentMethod,
  getCharges,
  getNextInvoice

} from './UserApi'

export {
  getOrg,
  updateOrg,
  patchOrg,
  createInvite,
  getAllInvites,
  resendInvite,
  cancelInvite,
  getCollaborators,
  deleteCollaborator,
  getOrgSubscription,
  cancelOrgSubscription,
  renewOrgSubscription,
  getOrgPaymentMethod,
  updateOrgPaymentMethod,
  getOrgCharges,
  getOrgNextInvoice
} from './OrgApi'

export {
  getAllSettings,
  updateSetting
} from './SettingsApi'




// WEBPACK FOOTER //
// ./src/api/index.js